
import { useGetRequest } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import { defineComponent, reactive, toRefs } from 'vue'
import { fDatetime2Time, fDatetime2FromNowStr } from '@/filters'

export default defineComponent({
  setup() {
    const state = reactive({
      isLoading: true,
      groups: [],
    })

    useGetRequest('/api/blog/groups_by_day').then((res) => {
      AssertGoodResponse(res)
      state.groups = res.data.data
      state.isLoading = false
    })

    return {
      ...toRefs(state),
      fDatetime2Time,
      fDatetime2FromNowStr,
    }
  },
})
